export enum ChannelEndpoints {
  ROOT = '/channels',
}

export const staticChannelEndpoints = {
  GET_CHANNELS: ChannelEndpoints.ROOT,
  CREATE_CHANNEL: ChannelEndpoints.ROOT,
};

export const getChannelEndpoints = ({ id }: { id: number }) => ({
  UPDATE_CHANNEL: `${ChannelEndpoints.ROOT}/${id}`,
});

export enum ModelSearchType {
  DATES = 'dates',
  NOTHING = 'nothing',
  SERIAL_NUMBER = 'serialNumber',
}

export interface IChannel {
  id: number;
  slug: string;
  name: string;
  status: ChannelStatus;
  type: ChannelType;
  // description: null | string;
  siteUrl: string;
  hideSerialNumber: boolean;
  hideModelYearRange: boolean;
  createdAt: Date;
  modelSearchType: ModelSearchType;
}

export enum ChannelStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum ChannelType {
  PRODUCTS = 'PRODUCTS',
  PARTS = 'PARTS',
  SHOWCASE = 'SHOWCASE',
}
// ============== DTO ==============

export type IUpdateChannelDTO = Partial<
  Pick<IChannel, 'name' | 'status' | 'siteUrl' | 'hideModelYearRange' | 'hideSerialNumber'>
> & {
  id: number;
};

export interface ICreateChannelDTO
  extends Pick<IChannel, 'name' | 'siteUrl' | 'slug' | 'type' | 'hideModelYearRange' | 'hideSerialNumber'> {
  copyChannelId: number;
}

// ============== Response ==============

export type ICreateChannelResponse = IChannel;

export type IUpdateChannelResponse = IChannel;

export type IGetChannelsResponse = IChannel[];
